/**
 * @generated SignedSource<<b194440f05d3289977708368c0fb0058>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { InlineFragment, ReaderInlineDataFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type helpersAppBarVariantArticle$data = {
  readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIsLongReadArticle" | "helpersCheckIsMorningStudioArticle" | "helpersCheckIsPhotoEssayArticle" | "helpersCheckIsPostiesArticle" | "helpersCheckIsPostiesPage" | "helpersCheckIsStyleArticle" | "helpersStyleSectionContent">;
  readonly " $fragmentType": "helpersAppBarVariantArticle";
};
export type helpersAppBarVariantArticle$key = {
  readonly " $data"?: helpersAppBarVariantArticle$data;
  readonly " $fragmentSpreads": FragmentRefs<"helpersAppBarVariantArticle">;
};

const node: ReaderInlineDataFragment = {
  "kind": "InlineDataFragment",
  "name": "helpersAppBarVariantArticle"
};

(node as any).hash = "7a9e0942db01cf8e91bc634a563d8c8a";

export default node;
